<div class="top-menu">
    <p-button label="View" (onClick)="goToViewMode()"></p-button>
</div>
<div [formGroup]="parentForm">
    <table formArrayName="items">
        <tr>
            <th>Booking id</th>
            <th>
                Start
            </th>
            <th>
                End
            </th>
            <th>
                Conf total
            </th>
            <th>
                Insurance
            </th>
            <th>
                Cancellation
            </th>
            <th>
                School Invoice
            </th>
            <th>
                Received already
            </th>
            <th>
                Remaining balance
            </th>
            <th>
                Gross margin
            </th>
            <th>
                School
            </th>
            <th>
                Info
            </th>
            <th>
                Commission
            </th>
            <th>
                Paid already
            </th>
        </tr>
        <tr *ngFor="let booking of commissions; let i = index" [formGroupName]="i">
            <td>
                <a target="_blank" [href]="baseUrl + '/management/edit-booking/' + booking.bookingId">
                    {{booking.bookingId}}
                </a>
            </td>
            <td class="td-with-padding">
                {{booking.startDate.format("DD/MM/YYYY")}}
            </td>
            <td class="td-with-padding">
                {{booking.endDate.format("DD/MM/YYYY")}}
            </td>
            <td>
                {{booking.confirmationAmount}}
            </td>
            <td>
                {{booking.insurance}}
            </td>
            <td>
                {{booking.cancellationInsurance}}
            </td>
            <td>
                {{booking.totalSchoolInvoice}}
            </td>
            <td>
                {{booking.receivedFromClient}}
            </td>
            <td>
                {{booking.remainingBalance}}
            </td>
            <td>
                {{booking.grossMargin}}
            </td>
            <td>
                {{booking.school.name}}
            </td>
            <td>
                <span class="error-message">
                    {{booking.info}}
                </span>
            </td>
            <td>
                {{booking.commissionStr}}
            </td>
            <td>
                <p-checkbox formControlName="isCommissionPaid" [binary]="true" (onChange)="isCommissionPaidChange(booking.bookingId, $event.checked)"></p-checkbox>
            </td>
        </tr>
    </table>
</div>